// src/components/MangoCategories/MangoCategories.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./mango-categories.css";

const MangoCategories = ({ categories, onSelectCategory }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    if (onSelectCategory) {
      onSelectCategory(category);
    }
  };

  return (
    <section className="mango-categories">
      <div className="mango-categories-container">
        <h2 className="mango-categories-title">Our Mango Varieties 🥭</h2>
        <p className="mango-categories-subtitle">
          Premium quality mangoes directly from the farm
        </p>

        <div className="mango-categories-grid">
          {categories.map((category) => (
            <div
              key={category.id}
              className="mango-category-card"
              onClick={() => handleCategoryClick(category)}
            >
              <div className="mango-category-image-wrapper">
                <img
                  src={category.image}
                  alt={category.name}
                  className="mango-category-image"
                />
                <div className="mango-category-badge">{category.origin}</div>
              </div>
              <div className="mango-category-info">
                <h3 className="mango-category-name">{category.name}</h3>
                <p className="mango-category-description">
                  {category.description}
                </p>
                <div className="mango-category-variants">
                  {category.variants.map((variant, index) => (
                    <span key={index} className="mango-variant-tag">
                      {variant.weight}: ৳{variant.price}
                    </span>
                  ))}
                </div>
                <button
                  className="mango-select-btn btn btn-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCategoryClick(category);
                  }}
                >
                  Select Variant →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MangoCategories;
